import script from "./old_teacher-superiority.vue?vue&type=script&setup=true&lang=js"
export * from "./old_teacher-superiority.vue?vue&type=script&setup=true&lang=js"

import "./old_teacher-superiority.vue?vue&type=style&index=0&id=07a2f00b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07a2f00b"]])

export default __exports__